/**
 * Public pages rendered by the API (rai.site), not by this app. They live at
 * the site root next to the React pages, so a link to one must load a new
 * page instead of going through the router. nginx and the Vite dev proxy send
 * these paths to the API; keep this list in step with rai.site.paths
 * (tests/unit/test_site_nav.py checks it).
 */
export const SERVER_SECTIONS = [
  "share-market-today",
  "top-gainers",
  "top-losers",
  "52-week-high",
  "52-week-low",
  "most-active",
  "indices",
  "stocks",
  "sectors",
  "research-analysts",
  "research-analyst",
  "investment-advisers",
  "investment-adviser",
  "how-it-works",
  "sitemaps",
] as const;

const SERVER_RE = new RegExp(`^/(${SERVER_SECTIONS.join("|")})(/|$|\\?)`);

/** True for a path served by the server-rendered site ("/stocks/tcs", "/indices"). */
export function isServerPath(to: string): boolean {
  return SERVER_RE.test(to);
}
